import { render } from "./ConstraintIssuers.vue?vue&type=template&id=18a1f248"
import script from "./ConstraintIssuers.vue?vue&type=script&lang=js"
export * from "./ConstraintIssuers.vue?vue&type=script&lang=js"

import exportComponent from "/home/syhpoon/UNIX/wealthpic/js/wealthpic-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__